import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { Link } from '@spotahome/ui-library';
import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';
import GridInfo from '@spotahome/ui-library/src/tenant/components/GridInfo';

import './Blog.scss';

const Blog = ({ mainPosts, otherPosts }) => {
  const positionsWithImage = [1, 2];

  const gridItems = mainPosts.map((post, index) => {
    const hasImage = positionsWithImage.includes(index);
    return {
      titleTag: 'h4',
      title: post.title,
      description: post.description,
      cta: {
        text: trans('seo.country.blog.read.full.article'),
        url: post.url,
        type: 'link',
        onClick: () => {
          SoyuzAnalytics.sendGA4Event('send', {
            section: 'country-blog-main-post',
            action: 'click'
          });
        }
      },
      hideImageOnMobile: true,
      ...(hasImage && {
        renderImage: className => (
          <img
            src={post.image}
            alt={post.title}
            className={classNames(className, 'blog-section__post__image')}
          />
        )
      }),
      className: 'blog-section__post'
    };
  });

  if (mainPosts.length === 0 && otherPosts.length === 0) {
    return null;
  }

  return (
    <LandingSection
      className="blog-section"
      containerClassName="blog-section__container"
      observableSection="articles"
    >
      {mainPosts.length > 0 && (
        <section>
          <h3 className="blog-section__title">
            {trans('seo.country.blog.main.posts.title')}
          </h3>
          <GridInfo items={gridItems} />
        </section>
      )}
      {otherPosts.length > 0 && (
        <section>
          <h3 className="blog-section__title blog-section__title--small">
            {trans('seo.country.blog.other.posts.title')}
          </h3>
          <ul className="blog-section__other-posts">
            {otherPosts.map(post => (
              <li key={post.url} className="blog-section__other-post">
                <Link
                  href={post.url}
                  onClick={() => {
                    SoyuzAnalytics.sendGA4Event('send', {
                      section: 'country-blog-other-post',
                      action: 'click'
                    });
                  }}
                >
                  {post.title}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}
    </LandingSection>
  );
};

export default Blog;
